import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export interface ShortUrlParamsHook {
  url: string;
  search?: URLSearchParams;
}

export function useShortUrlParams(): ShortUrlParamsHook {
  const { pathname, search: encodedSearch } = useLocation();

  const url = useMemo(() => {
    if (!pathname) return '';
    return pathname.replace(/\//g, '');
  }, [pathname]);

  const search = useMemo(() => {
    if (!encodedSearch) return undefined;
    return new URLSearchParams(encodedSearch);
  }, [encodedSearch]);

  return {
    url,
    search,
  };
}
